<template>
  <section class="process">
    <div class="title">
      <p>轻松<span>4</span>步享购</p>
    </div>
    <div class="content">
      <img src="https://image.suhuishou.com/attached/upload/20220918/20220918225533_5157.png" alt="" />
    </div>
    <!-- <div class="box">
      <div class="item">
        <div class="icon"></div>
        <p>01</p>
        <p>旧机评估</p>
      </div>
      <div class="item">
        <div class="icon"></div>
        <p>02</p>
        <p>领取补助金</p>
      </div>
      <div class="item">
        <div class="icon"></div>
        <p>03</p>
        <p>回收旧机</p>
      </div>
      <div class="item">
        <div class="icon"></div>
        <p>04</p>
        <p>购买新机</p>
      </div>
    </div> -->
  </section>
</template>
<script>
export default {

}
</script>
<style scoped>
.process {
  position: relative;
  margin: 120px auto 0;
  width: 1200px;
  background: #FFFFFF;
  box-shadow: 3px 0px 21px 0px rgba(51,51,51,0.22);
  border-radius: 36px;
  padding: 114px 0 90px;
}
.process .title {
  position: absolute;
  top: -35px;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 765px;
  height: 70px;
  background: linear-gradient(90deg, #FD704D 0%, #FA4448 100%);
  border-radius: 35px;

}
.process .title p{
  position: absolute;
  top: -20px;
  left: 0;
  right: 0;
  text-align: center;
  font-size: 32px;
  line-height: 65px;
  height: 65px;
  color: #fff;
  font-weight: 500;
  font-style: italic;
  text-shadow: 3px 0px 6px rgba(51,51,51,0.47);
}
.process .title p span{
  font-size: 65px;

}
.process .content img{
  width: 884px;
  display: block;
  margin: 0 auto;
}

/* https://image.suhuishou.com/attached/image/20190814/20190814110155_25446.png */
/* .process .box {
  display: flex;
  margin-top: 42px;
}
.process .box .item {
  text-align: center;
  width: 261px;
  margin-right: 39px;
  position: relative;
}
.process .box .item:last-child::before {
  display: none;
}
.item:before {
  position: absolute;
  display: inline-block;
  width: 38px;
  height: 16px;
  content: "";
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAQCAMAAABNwP0sAAAAaVBMVEUAAAD0RF/0RF/0RF/0RF/0RF/0RF/0RF/0RF/0RF/0RF/0RF/0RF/0RF/0RF/0RF/0RF/0RF/0RF/0RF/0RF/0RF/0RF/0RF/0RF/0RF/0RF/0RF/0RF/0RF/0RF/0RF/0RF/0RF/0RF+zUfODAAAAInRSTlMADmdbFQjTyD0D2r+lTCkc9PHOxpmKePjrtrCfl5F6eWswSZFVBAAAAJdJREFUKM+V0NcSwiAURdEbAxjTu73t//9IQyagMzqi6+1cDmWQb65tLGEaWElY9lsvWv/d04PpYvGSLO3Vh96RSexbNrWbt57C6tw4n2MinqphW0mJZdx0P8fCtzb5cpdhMrjxzaYm8rUTMMqkTOGg/e4eds/DRuC8rJSVvFB3LU4M5BJSAJkOfm4DJpJgrSZVEpZc3Ksf82UORIiSNhUAAAAASUVORK5CYII=)
    no-repeat;
  right: -40px;
  top: 22%;
}
.process .box .item:last-child {
  margin-right: 0;
}
.process .box .item .icon {
  width: 107px;
  height: 110px;
  background: url(https://image.suhuishou.com/attached/image/20190814/20190814110155_25446.png)
    no-repeat;
  background-size: 979px;
  margin: 25px auto 0;
}
.process .box .item:nth-child(2) .icon {
  background-position: -296px 0;
}
.process .box .item:nth-child(3) .icon {
  background-position: -591px 0;
}
.process .box .item:nth-child(4) .icon {
  background-position: -872px 0;
}
.process .box .item p:nth-child(2) {
  font-size: 22px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: #999;
  line-height: 14px;
  margin: 66px 0 23px;
}
.process .box .item p:nth-child(3) {
  font-size: 20px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 14px;
  margin: 6px 0 53px;
} */
</style>